import { DataItem, DefaultListParams, IDropdownOption, Nullable } from '../common';
import { Organization } from './account';
import { Country } from './country';

export interface IFacilityService {
  type_of_asset: string;
  type_of_repairs: string[];
}

export interface IFocalPoint {
  email: string;
  first_name: string;
  full_name: string;
  is_active: boolean;
  last_name: string;
  uuid: string;
}

export type WorkSchedule = {
  start_time: string;
  end_time: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
};

export interface IFacilityBase {
  uuid: string;
  city_name: string;
  country_name: string;
  facility_id_on_hbh: number;
}

export interface IFacility {
  address: string;
  agency: string;
  allowed_agencies: Nullable<string[]>;
  city: Nullable<string>;
  city_name: string;
  country: Nullable<Country>;
  country_name: string;
  email: string;
  facility_id_on_hbh: number;
  fms_workshop_id: string;
  image: Nullable<string>;
  latitude: number;
  longitude: number;
  name: string;
  services: IFacilityService[];
  uuid: string;
  work_time: Nullable<WorkSchedule>;
}

export enum FacilityStatus {
  ACTIVE = 'Active',
  ARCHIVED = 'Archived',
  HIDDEN = 'Hidden',
}

export interface IAdminFacility {
  city_name: string;
  country_name: string;
  depot_name: Nullable<string>;
  email: string;
  facility_id_on_hbh: number;
  facility_status: FacilityStatus;
  name: string;
  uuid: string;
}

export interface IAdminFacilitiesListParams extends DefaultListParams {
  country?: string;
}

export interface IAdminFacilitiesFilters {
  countries: DataItem[];
}

export interface IAdminFacilitiesOptions {
  countries: DataItem[];
  depots: DataItem[];
  global_visibility_rules: DataItem[];
  organisations: DataItem[];
  type_of_assets: DataItem[];
  type_of_repairs: DataItem[];
  users: DataItem[];
}

export interface IAdminFacilityDetails {
  address: string;
  agency: string;
  allowed_organisations: Organization[];
  city_name: string;
  country: Country;
  country_name: string;
  depot: Nullable<IDropdownOption>;
  email: string;
  global_visibility_rules: number;
  id: string;
  image: string;
  is_active: boolean; // TO DO: Need check BE
  latitude: number;
  longitude: number;
  name: string;
  services: IFacilityService[];
  work_time: WorkSchedule;
  focal_points: {
    email: string;
    first_name: string;
    last_name: string;
  }[];
}

// Note: convert to FormData
export interface FacilityFormData {
  address: string;
  archive_notification: boolean;
  agency: string; // TO DO: No need
  allowed_organisations: string[];
  city_name: string;
  country_iso_code: string;
  depot_number: number;
  email: string;
  focal_points: string[];
  global_visibility_rules: number;
  image: string;
  latitude: number;
  longitude: number;
  name: string;
  services: IFacilityService[];
  work_time: WorkSchedule;
}

export interface BookingArchive {
  created: string;
  jobcard_number: string;
  plate_number: string;
  request_number: string;
  requesting_agency: string;
  state: string;
  type_of_asset: string;
  uuid: string;
}

export interface BookingArchiveResponse {
  bookings: BookingArchive[];
}

export enum FmsSyncTasks {
  ASSETS = 'assets',
  JOBCARDS = 'jobcards',
  MECHANICS = 'mechanics',
  DEPOTS = 'depots',
  CUSTOMERS = 'customers',
}

export interface FmsSyncInfo {
  in_progress: string;
  last_synced_at: string;
}
